import { Button, Card, Col, Flex, Modal, Row, Space } from "antd";
import { useTranslation } from "react-i18next";
import { ReactComponent as ExcelIcon } from "../../../assets/icon/excelIcon.svg";
import { ReactComponent as DownloadIcon } from "../../../assets/icon/downloadIcon.svg";
import { ReactComponent as PDFIcon } from "../../../assets/icon/pdfIcon.svg";

const DownloadEmployeeSalaryModal = ({
    isModalSalaryOpen = false,
    setIsModalSalaryOpen = () => { },
    isDownload = false,
    isSlipDownload = false,
    exportTxnPayment = () => { },
    exportPaymentSlip = () => { }
}) => {
    const { t } = useTranslation();

    return (
        <Modal
            title={<span color="#42526D">{t("report.label.download_file")}</span>}
            destroyOnClose
            open={isModalSalaryOpen}
            footer={null}
            closable={false}
            maskClosable={false}
        >
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <span style={{ fontSize: "14px", color: "#667085" }}>
                    {t("report.modal.description")}
                </span>

                <Card
                    style={{ backgroundColor: "#F5F6F7", border: "1px solid #E4E7EC", borderRadius: "12px" }}
                    styles={{ body: { padding: "16px" } }}
                >
                    <Row style={{ width: "100%" }}>
                        <Col span={16}>
                            <Flex gap={16} align="center">
                                <ExcelIcon />
                                <Flex vertical>
                                    <span style={{ fontWeight: "bold", color: "#42526D" }}>{t("payment.label.salary_report")}</span>
                                    <span style={{ color: "#42526D" }}>{t("common.excel_file")}</span>
                                </Flex>
                            </Flex>
                        </Col>
                        <Col span={8} style={{ alignContent: "center", justifyItems: "flex-end" }}>
                            <Button type="default" style={{ height: "40px", borderRadius: "8px", display: "flex", alignItems: "center" }}
                                onClick={() => { exportTxnPayment(); }}
                                disabled={isDownload}
                                loading={isDownload}
                                icon={
                                    !isDownload ? (
                                        <DownloadIcon style={{ fontSize: 16 }} />
                                    ) : (
                                        <span style={{ width: 16, height: 16 }} />
                                    )
                                }
                            >
                                <span style={{ color: "#59687F", fontWeight: "bold" }}>{t("common.download")}</span>
                            </Button>
                        </Col>
                    </Row>
                </Card>

                <Card
                    style={{ backgroundColor: "#F5F6F7", border: "1px solid #E4E7EC", borderRadius: "12px" }}
                    styles={{ body: { padding: "16px" } }}
                >
                    <Row style={{ width: "100%" }}>
                        <Col span={16}>
                            <Flex gap={16} align="center">
                                <PDFIcon />
                                <Flex vertical>
                                    <span style={{ fontWeight: "bold", color: "#42526D" }}>{t("payment.label.salary_slip")}</span>
                                    <span style={{ color: "#42526D" }}>{t("common.pdf_file")}</span>
                                </Flex>
                            </Flex>
                        </Col>
                        <Col span={8} style={{ alignContent: "center", justifyItems: "flex-end" }}>
                            <Button
                                type="default"
                                style={{ height: "40px", borderRadius: "8px", display: "flex", alignItems: "center" }}
                                onClick={() => { exportPaymentSlip() }}
                                loading={isSlipDownload}
                                disabled={isSlipDownload}
                                icon={
                                    !isSlipDownload ? (
                                        <DownloadIcon style={{ fontSize: 16 }} />
                                    ) : (
                                        <span style={{ width: 16, height: 16 }} />
                                    )
                                }
                            >
                                <span style={{ color: "#59687F", fontWeight: "bold" }}>{t("common.download")}</span>
                            </Button>
                        </Col>
                    </Row>
                </Card>

                <Row justify={"end"} style={{ gap: "16px" }}>
                    <Button style={{ borderRadius: "8px", height: "40px" }} type="default" onClick={() => { setIsModalSalaryOpen(false) }}>
                        <span style={{ fontWeight: "bold", color: "#344054" }}>{t("common.cancel").toUpperCase()}</span>
                    </Button>
                </Row>
            </Space>
        </Modal>
    )
}

export default DownloadEmployeeSalaryModal;